/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const productPosService = {
  getList: (params: any) => request.get('/product/pos', { params }),
  getProductPosById: (id: any) => request.get(`/product/pos/${id}`),
  createProductPos: (data: any) => request.post('/product/pos', data),
  deleteProductPos: (id: any) => request.delete(`/product/pos/${id}`),
  updateProductPos: (id: any, data: any) =>
    request.put(`/product/pos/${id}`, data)
};

export default productPosService;
